import Head from 'next/head';
import { LANDING_PRELOAD_IMAGES } from '../lib';

const LandingPageHead = () => {
  return (
    <Head>
      {LANDING_PRELOAD_IMAGES.map((image) => (
        <link key={image.href} rel='preload' as='image' type={image.type} href={image.href} />
      ))}
    </Head>
  );
};

export default LandingPageHead;
